import { apiV1Client } from "../lib/apiClient";
import { UpdateAccountInputType } from "../schemas/userSchema";
import { ApiResponse } from "../types/api";
import { ME_OPERATIOSNS } from "../types/operations";
import { LoginUser, LoginUserResponse } from "../types/response/loginUser";
import { TenantWithBuildingTreeList } from "../types/response/tenant";

const mePath = "/user";

/**
 * ログインユーザー詳細を取得するリクエストを送信する
 */
export const callGetMe = async (): Promise<LoginUser> => {
  const res = await apiV1Client.post<ApiResponse<LoginUserResponse>>(mePath, {
    operation: ME_OPERATIOSNS.me.get,
  });
  return res.data.data;
};

/**
 * ログインユーザー情報を更新するリクエストを送信する
 */
export const callUpdateMe = async (
  input: UpdateAccountInputType
): Promise<LoginUser> => {
  const res = await apiV1Client.post<ApiResponse<LoginUserResponse>>(mePath, {
    operation: ME_OPERATIOSNS.me.update,
    data: { ...input },
  });
  return res.data.data;
};

/**
 * 管理範囲内の地域ネスト構造一覧を取得する
 */
export const callListMyBuildingTree =
  async (): Promise<TenantWithBuildingTreeList> => {
    const res = await apiV1Client.post<ApiResponse<TenantWithBuildingTreeList>>(
      mePath,
      {
        operation: ME_OPERATIOSNS.buildingTree.get,
      }
    );
    return res.data.data;
  };

type SetCurrentBuilding = {
  buildingId: string;
};

export const callMySetCurrentBuilding = async (
  input: SetCurrentBuilding
): Promise<LoginUser> => {
  const res = await apiV1Client.post<ApiResponse<LoginUserResponse>>(mePath, {
    operation: ME_OPERATIOSNS.me.setBuilding,
    data: {
      buildingId: input.buildingId,
    },
  });
  return res.data.data;
};
